import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/Home/HomePage';
import ArticlePage from './pages/Articles/ArticlePage';
import CategoryPage from './pages/Categories/CategoryPage';
import GettingStartedPage from './pages/GettingStarted/GettingStartedPage';
import ContactPage from './pages/Contact/ContactPage';
import PrivacyPolicy from './pages/Legal/PrivacyPolicy';
import TermsOfService from './pages/Legal/TermsOfService';
import Layout from './components/Layout/Layout';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/articles/:category/:slug" element={<ArticlePage />} />
        <Route path="/categories/:category" element={<CategoryPage />} />
        <Route path="/getting-started" element={<GettingStartedPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="*" element={
          <Layout>
            <div className="max-w-7xl mx-auto px-4 py-12 text-center">
              <h1 className="text-3xl font-bold">Page Not Found</h1>
              <p className="mt-4">The page you're looking for doesn't exist.</p>
            </div>
          </Layout>
        } />
      </Routes>
    </Router>
  );
}

export default App;